import React, { FC, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { activeFontStyles, containerStyle, fontStyles } from "./sortByStyles";
import dropdownIcon from "../../assets/drop-down.svg";

type SortByProps = {
  selected: string;
  options: string[];
  setSelected: (value: string) => void;
};

const SortBy: FC<SortByProps> = ({ options, selected, setSelected }) => {
  const [open, setOpen] = useState(false);
  const optionsLength = options.length;

  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Box
        sx={{
          ...containerStyle,
          width: { xs: "108px", sm: "120px" },
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography sx={fontStyles}>
          Sort by : <span style={activeFontStyles as any}>{selected}</span>{" "}
        </Typography>
        <img
          src={dropdownIcon}
          style={{ rotate: open ? "0deg" : "180deg" }}
          alt=""
          width="9.3px"
        />
      </Box>
      {open && (
        <Box
          sx={{
            ...containerStyle,
            display: "flex",
            flexDirection: "column",
            mt: "45px",
            position: "absolute",
            zIndex: 2000,
            width: { xs: "108px", sm: "120px" },
          }}
        >
          {options.map((option, idx) => (
            <>
              <Typography
                key={option}
                sx={activeFontStyles}
                onClick={() => {
                  setSelected(option);
                  setOpen(false);
                }}
              >
                {option}
              </Typography>
              <Divider hidden={idx + 1 === optionsLength} sx={{ my: "5px" }} />
            </>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SortBy;
